/** Render typed initials onto a small canvas for portal deliverable approval records. */
export function initialsSignatureDataUrl(initials: string): string {
  const text = initials.trim().toUpperCase();
  const canvas = document.createElement('canvas');
  canvas.width = 220;
  canvas.height = 72;
  const ctx = canvas.getContext('2d');
  if (!ctx) return '';
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#0f172a';
  ctx.font = 'italic 36px Georgia, "Times New Roman", serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(text, canvas.width / 2, canvas.height / 2);
  return canvas.toDataURL('image/png');
}

export function isValidApprovalInitials(initials: string): boolean {
  const trimmed = initials.trim();
  return trimmed.length >= 2 && trimmed.length <= 8;
}
